export default __webpack_public_path__ + "static/media/Marquise_product.394b4f0a.png";